import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-feedback-qualita',
  templateUrl: './feedback-qualita.component.html',
  styleUrls: ['./feedback-qualita.component.css']
})
export class FeedbackQualitaComponent implements OnInit {
  error = "no_error";
  scoreNumber: number = 5;

  list;
  @Input() form;
  @Input() desc;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.getList();
  }

  score(event) {
    if (event.srcElement.checked) {
      this.scoreNumber--;
    } else {
      this.scoreNumber++;
    }
  }

  getList() {
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("RATING_QUALITA")
      .subscribe(
        (data) => {
          this.list = data.items;
          console.log("RATING_QUALITA " + JSON.stringify(this.list));
        },
        (error) => {
          this.error = "Impossibile caricare la lista RATING_QUALITA";
          console.log(error);
        }
      );
  }

}
